import React from "react";

export default function InputText({label, onChange, onblur, data, type, name, maxLength, minLength, className}) {

    return <div className={`form-item form-item--${name}`}>
        <label>{label}</label>
        <input onBlur={onblur} minLength={minLength} maxLength={maxLength} onChange={onChange} value={data.value} className={`${className ? className : ''} ${(data.touched ? (data.valid ? 'valid' : 'error') : '')}`} type={type} name={name}/>
        {((!data.valid) && data.touched) ? <span className="error">{ data.error ? data.error : 'Questo campo è obbligatorio'}</span>: '' }
    </div>
}